import styled from 'styled-components';

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
`;

const Chip = styled.button`
  padding: 10px 20px;
  border: 2px solid ${props => props.$isSelected ? '#007bff' : '#dee2e6'};
  background-color: ${props => props.$isSelected ? '#007bff' : 'white'};
  color: ${props => props.$isSelected ? 'white' : '#333'};
  border-radius: 24px;
  font-size: 15px;
  font-weight: ${props => props.$isSelected ? '600' : '500'};
  cursor: pointer;
  transition: all 0.2s;
  outline: none;

  &:hover {
    border-color: #007bff;
    background-color: ${props => props.$isSelected ? '#0056b3' : '#f0f7ff'};
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

const Chips = ({ options, value, onChange, label }) => {
  return (
    <div>
      {label && <div style={{ fontSize: '14px', color: '#666', marginBottom: '12px', fontWeight: '500' }}>{label}</div>}
      <ChipsContainer>
        {options.map((option) => (
          <Chip
            key={option}
            $isSelected={value === option}
            onClick={() => onChange(option)}
          >
            {option}
          </Chip>
        ))}
      </ChipsContainer>
    </div>
  );
};

export default Chips;
